// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"198":"37ef2f7f","585":"37ef2f7f","633":"37ef2f7f"}[chunkId] + ".chunk.css";
};